import { CheckCircle2, XCircle, Clock } from "lucide-react";

export function formatDate(iso) {
  return new Date(iso).toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export const statusMap = {
  available: { label: "Présent", color: "emerald", Icon: CheckCircle2 },
  unavailable: { label: "Absent", color: "rose", Icon: XCircle },
  pending: { label: "Incertain", color: "amber", Icon: Clock },
};

export const sideMeta = {
  bleus: {
    label: "Les Bleus",
    color: "#60A5FA",
    bg: "sky",
    darkBg: "bg-sky-500/10",
    chip: "bg-sky-500/20 text-sky-300 border-sky-500/30",
  },
  rouges: {
    label: "Les Rouges",
    color: "#DC2626",
    bg: "rose",
    darkBg: "bg-rose-500/10",
    chip: "bg-rose-500/20 text-rose-300 border-rose-500/30",
  },
};
